import {
  RESET_AVAILABILITY,
  CREATE_AVAILABILITY,
  CREATED_AVAILABILITY,
  GET_AVAILABILITIES,
  SET_AVAILABILITIES,
  API_ERROR,
  GET_AVAILABILITY,
  SET_AVAILABILITY,
  EDIT_AVAILABILITY,
  EDIT_AVAILABILITY_SUCCESS,
  DELETE_AVAILABILITY,
  DELETE_AVAILABILITY_SUCCESS,
  UPDATE_AVAILABILITY,
  UPDATE_AVAILABILITY_SUCCESS,
  UPDATE_AVAILABILITY_AGENT,
  UPDATE_AVAILABILITY_AGENT_SUCCESS,
  UPDATE_AVAILABILITY_SIGNALR,
  UPDATE_AVAILABILITY_SIGNALR_SUCCESS,
  RESET_UPDATE_AGENT,
  RESET_AVAILABILITIES,
  RESET_ERROR,
  REVALIDATE_AVAILABILITY,
  API_ERROR_CRUD,
} from "./actionTypes";

const initialState = {
  errorAvailability: false,
  errorAvailabilityCRUD: false,
  loadingAvailability: false,
  dataAvailability: null,
  successAvailability: false,
  activeAvailability: null,
};

const Availability = (state = initialState, action) => {
  switch (action.type) {
    case RESET_AVAILABILITIES:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailability: false,
        loadingAvailabilityDelete: false,
        successAvailability: false,
        dataAvailability: null,
        dataAvailabilityDelete: null,
      };
      break;
    case RESET_AVAILABILITY:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailability: false,
        successAvailability: false,
        dataAvailabilityGetSet: null,
        dataAvailabilityEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailability: false,
        loadingAvailabilityEditCreate: false,
        loadingAvailabilityActivate: false,
        successAvailability: false,
      };
      break;
    case GET_AVAILABILITIES:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailability: true,
        dataAvailability: null,
      };
      break;
    case SET_AVAILABILITIES:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailability: false,
        dataAvailability: action.payload,
      };
      break;
    case CREATE_AVAILABILITY:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailabilityEditCreate: true,
        dataAvailabilityEditCreate: action.payload,
        successAvailability: false,
      };
      break;
    case CREATED_AVAILABILITY:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailabilityEditCreate: false,
        dataAvailabilityEditCreate: action.payload,
        successAvailability: true,
      };
      break;
    case GET_AVAILABILITY:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailability: true,
        dataAvailabilityGetSet: null,
      };
      break;

    case SET_AVAILABILITY:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailability: false,
        dataAvailabilityGetSet: action.payload,
      };
      break;

    case EDIT_AVAILABILITY:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailabilityEditCreate: true,
        dataAvailabilityEditCreate: action.payload,
        successAvailability: false,
      };
      break;

    case EDIT_AVAILABILITY_SUCCESS:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: false,
        loadingAvailabilityEditCreate: false,
        dataAvailabilityEditCreate: action.payload,
        successAvailability: true,
      };
      break;
    case API_ERROR_CRUD:
      state = {
        ...state,
        errorAvailability: false,
        errorAvailabilityCRUD: action.payload,
        loadingAvailability: false,
        loadingAvailabilityDelete: false,
        successAvailability: false,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorAvailability: action.payload,
        loadingAvailability: false,
        loadingAvailabilityDelete: false,
        successAvailability: false,
        successUpdateAvailabilityAgent: false,
        loadingUpdateAvailability: false,
      };
      break;
    case DELETE_AVAILABILITY:
      state = {
        ...state,
        errorAvailability: false,
        loadingAvailabilityDelete: true,
        dataAvailabilityDelete: action.payload,
        successAvailability: false,
      };
      break;
    case DELETE_AVAILABILITY_SUCCESS:
      state = {
        ...state,
        errorAvailability: false,
        loadingAvailabilityDelete: false,
        dataAvailabilityDelete: action.payload,
        successAvailability: true,
      };
      break;
    case UPDATE_AVAILABILITY:
      state = {
        ...state,
        loadingUpdateAvailability: true,
        successUpdateAvailability: false,
      };
      break;
    case UPDATE_AVAILABILITY_SUCCESS:
      state = {
        ...state,
        loadingUpdateAvailability: false,
        successUpdateAvailability: true,
        activeAvailability: action.payload.availId,
      };
      break;

    case UPDATE_AVAILABILITY_AGENT:
      state = {
        ...state,
        loadingUpdateAvailabilityAgent: true,
        successUpdateAvailabilityAgent: false,
      };
      break;

    case UPDATE_AVAILABILITY_AGENT_SUCCESS:
      state = {
        ...state,
        loadingUpdateAvailabilityAgent: false,
        successUpdateAvailabilityAgent: true,
      };
      break;

    case UPDATE_AVAILABILITY_SIGNALR:
      state = {
        ...state,
        loadingUpdateAvailabilitySignalr: true,
        successUpdateAvailabilitySignalr: false,
      };
      break;
    case REVALIDATE_AVAILABILITY:
      state = {
        ...state,
        revalidateAvailability: new Date(),
        activeAvailability: action.payload.availId,
      };
      break;
    case UPDATE_AVAILABILITY_SIGNALR_SUCCESS:
      state = {
        ...state,
        loadingUpdateAvailabilitySignalr: false,
        successUpdateAvailabilitySignalr: true,
        activeAvailability: action.payload.availId,
      };
      break;

    case RESET_UPDATE_AGENT:
      state = {
        ...state,
        loadingUpdateAvailabilitySignalr: false,
        successUpdateAvailabilitySignalr: false,
        loadingUpdateAvailabilityAgent: false,
        successUpdateAvailabilityAgent: false,
      };
      break;
    
    default:
      // state = { ...state, errorTab: false, loadingTab: false };
      break;
  }
  return state;
};

export default Availability;
